
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"512","height":"512","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"256","cy":"256","r":"256","fill":"#F3F4F7"}}),_c('path',{attrs:{"d":"M256 500c134.757 0 244-109.243 244-244S390.757 12 256 12 12 121.243 12 256s109.243 244 244 244z","fill":"#fff"}}),_c('path',{attrs:{"d":"M256 500.75c135.172 0 244.75-109.578 244.75-244.75S391.172 11.25 256 11.25 11.25 120.828 11.25 256 120.828 500.75 256 500.75z","stroke":"#D3D7E1","stroke-opacity":".5","stroke-width":"1.5","stroke-miterlimit":"10"}})])
          )
        }
      }
    